import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './containers/App';
import CalendarViewPage from './containers/CalendarViewPage';
import ChildWrapperPage from './containers/ChildWrapperPage';
import EventDetailPage from './containers/EventDetailPage';
import EventEditPage from './containers/EventEditPage';
import EventAddPage from './containers/EventAddPage';
import InboxPage from './containers/InboxPage';
import InboxDetailPage from './containers/InboxDetailPage';
import MyTripsPage from './containers/MyTripsPage';
import ScheduleListPage from './containers/ScheduleListPage';
import ScheduleViewPage from './containers/ScheduleViewPage';
import PageListPage from './containers/PageListPage';
import PageViewPage from './containers/PageViewPage';
import LoginPage from './containers/LoginPage';
import LogoutPage from './containers/LogoutPage';
import HandleToken from './containers/HandleToken';
import ActivatePage from './containers/ActivatePage';
import SignUpPage from './containers/SignUpPage';
import AccountPage from './containers/AccountPage';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={LoginPage} />

    <Route path="login" component={LoginPage} />
    <Route path="logout" component={LogoutPage} />
    <Route path="handleToken" component={HandleToken} />
    <Route path="activate" component={ActivatePage} />
    <Route path="signup" component={SignUpPage} />

    <Route path="calendar" component={ChildWrapperPage}>
      <IndexRoute component={CalendarViewPage} />

      <Route path="add" component={EventAddPage} />
      <Route path="details/:event_id" component={EventDetailPage} />
      <Route path="edit/:event_id" component={EventEditPage} />
      <Route path=":view" component={CalendarViewPage} />
      <Route path=":view/:year" component={CalendarViewPage} />
      <Route path=":view/:year/:month" component={CalendarViewPage} />
      <Route path=":view/:year/:month/:day" component={CalendarViewPage} />
    </Route>

    <Route path="account" component={AccountPage} />

    <Route path="inbox" component={ChildWrapperPage}>
      <IndexRoute component={InboxPage} />

      <Route path="details/:event_id" component={InboxDetailPage} />
    </Route>

    <Route path="schedule" component={ChildWrapperPage}>
      <IndexRoute component={ScheduleListPage} />

      <Route path="view/:schedule_id" component={ScheduleViewPage} />
    </Route>

    <Route path="page" component={ChildWrapperPage}>
      <IndexRoute component={PageListPage} />

      <Route path="view/:page_id" component={PageViewPage} />
    </Route>

    <Route path="myTrips" component={MyTripsPage} />

  </Route>
);



// WEBPACK FOOTER //
// ./src/app/routes.js